import { Dispatch } from "redux";
import { RoleList } from "./state";
import { UserRoleAction, initUserRoleAction } from "./action";


export function initUserRoleListThunk(RoleList:RoleList[]){
    return (dispatch: Dispatch<UserRoleAction>)=>{
        dispatch(initUserRoleAction(RoleList));  
    }
}

